import { useEffect, useState } from 'react';
import classNames from 'classnames';
import CardIcon, {
  Props as CardIconProps
} from '../../Molecules/CardIcon';

interface Props {
  cards: CardIconProps[];
  className?: string;
}

function CardIconList({ cards, className }: Props) {
  const timerDuration = 2;
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveStep(
        (prevActiveStep) =>
          (prevActiveStep + 1) % cards.length
      );
    }, timerDuration * 1000);

    return () => clearInterval(intervalId);
  }, [cards.length, timerDuration]);
  return (
    <div
      className={classNames([
        'relative flex w-full flex-col gap-7 rounded-xl bg-white p-7 @lg:flex-row',
        className
      ])}
    >
      {cards.map((card) => (
        <CardIcon
          key={cards.indexOf(card)}
          {...card}
          className={classNames([
            'absolute left-1/2 -translate-x-1/2 duration-300 first:relative first:left-auto first:translate-x-0 @lg:relative @lg:left-auto @lg:flex @lg:translate-y-0 @lg:translate-x-0 @lg:opacity-100',
            cards.indexOf(card) === activeStep
              ? 'translate-y-0 opacity-100'
              : 'translate-y-1/2 opacity-0'
          ])}
        />
      ))}
    </div>
  );
}

export default CardIconList;
